import { ADD_MESSAGE, CLOSE_MESSAGE, RESET_MESSAGES } from '../types';

export default (messages = [], action) => {
  switch(action.type) {
    case ADD_MESSAGE:
      const { message, variant, imageUrl, mobileImageUrl, link } = action;
      return [ ...messages, { message, variant, imageUrl, mobileImageUrl, link }];
    case CLOSE_MESSAGE:
      const msgs = [ ...messages ];
      msgs.shift()
      return msgs;
    case RESET_MESSAGES:
      return [];
    default:
      return messages;
  }
}
